import { render, staticRenderFns } from "./PageRouter.vue?vue&type=template&id=1c11486c&scoped=true"
import script from "./PageRouter.vue?vue&type=script&lang=js"
export * from "./PageRouter.vue?vue&type=script&lang=js"
import style0 from "./PageRouter.vue?vue&type=style&index=0&id=1c11486c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c11486c",
  null
  
)

export default component.exports